import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-ai-powered-lms-for-schools',
  templateUrl: './ai-powered-lms-for-schools.component.html',
  styleUrls: ['./ai-powered-lms-for-schools.component.scss']
})
export class AiPoweredLmsForSchoolsComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('AI-Powered LMS for Schools | Next-Gen Personalized Learning by Virsa');
    this.metaService.updateTag({ name: 'description', content: 'Discover Virsa AI-powered LMS with personalized learning, AI tutoring, automated assessments, real-time analytics, and smart classroom integration for modern education.' });
    this.metaService.updateTag({ name: 'keywords', content: 'AI-powered LMS for schools, Best AI LMS India, Personalized learning platform, AI tutoring for students, Smart classroom LMS, Automated assessments for schools, Real-time learning analytics, Virsa AI LMS, Digital learning ecosystem' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
